export default [
  {
    name: "Scrollx_Logo.png",
    thumbnail: "/LogoLibrary/ScrollX_LOGO_White.png",
    url: "/LogoLibrary/ScrollX_LOGO_White.png",
  },  
  // {
  //   name: "Scrollx_FaviconLogo.png",
  //   thumbnail: "/LogoLibrary/Scrollx_FaviconLogo.png",
  //   url: "/LogoLibrary/Scrollx_FaviconLogo.png",
  // },
  
  // {
  //   name: "A24",
  //   thumbnail: "/LogoLibrary/A24 copy.png",
  //   url: "/LogoLibrary/A24 copy.png",
  // },

  // {
  //   name: "20th-Century-Studios",
  //   thumbnail: "/LogoLibrary/20th-Century-Studios copy.png",
  //   url: "/LogoLibrary/20th-Century-Studios copy.png",
  // },

  // {
  //   name: "Affirm-Films ",
  //   thumbnail: "/LogoLibrary/Affirm-Films copy.png",
  //   url: "/LogoLibrary/Affirm-Films copy.png",
  // },
  

  // {
  //   name: "Amblin-Entertainment ",
  //   thumbnail: "/LogoLibrary/Amblin-Entertainment copy.png",
  //   url: "/LogoLibrary/Amblin-Entertainment copy.png",
  // },
  
  // {
  //   name: "American-Zoetrope  ",
  //   thumbnail: "/LogoLibrary/American-Zoetrope copy.png",
  //   url: "/LogoLibrary/American-Zoetrope copy.png",
  // },
  // {
  //   name: "Annapurna-Pictures  ",
  //   thumbnail: "/LogoLibrary/Annapurna-Pictures copy.png",
  //   url: "/LogoLibrary/Annapurna-Pictures copy.png",
  // },
  // {
  //   name: "Artisan-Entertainment  ",
  //   thumbnail: "/LogoLibrary/Artisan-Entertainment copy.png",
  //   url: "/LogoLibrary/Artisan-Entertainment copy.png",
  // },



  // {
  //   name: "Castle-Rock-Entertainment   ",
  //   thumbnail: "/LogoLibrary/Castle-Rock-Entertainment copy.png",
  //   url: "/LogoLibrary/Castle-Rock-Entertainment copy.png",
  // },
  // {
  //   name: "Columbia-Pictures",
  //   thumbnail: "/LogoLibrary/Columbia-Pictures copy.png",
  //   url: "/LogoLibrary/Columbia-Pictures copy.png",
  // },
  // {
  //   name: "Dimension-Films ",
  //   thumbnail: "/LogoLibrary/Dimension-Films copy.png",
  //   url: "/LogoLibrary/Dimension-Films copy.png",
  // },
  // {
  //   name: "Disney ",
  //   thumbnail: "/LogoLibrary/Disney copy.png",
  //   url: "/LogoLibrary/Disney copy.png",
  // },



  // {
  //   name: "Disneynature ",
  //   thumbnail: "/LogoLibrary/Disneynature copy.png",
  //   url: "/LogoLibrary/Disneynature copy.png",
  // },
  // {
  //   name: "E1-Entertainment ",
  //   thumbnail: "/LogoLibrary/E1-Entertainment copy.png",
  //   url: "/LogoLibrary/E1-Entertainment copy.png",
  // },
  // {
  //   name: "DreamWorks ",
  //   thumbnail: "/LogoLibrary/DreamWorks copy.png",
  //   url: "/LogoLibrary/DreamWorks copy.png",
  // },
  // {
  //   name: "Focus-Features ",
  //   thumbnail: "/LogoLibrary/Focus-Features copy.png",
  //   url: "/LogoLibrary/Focus-Features copy.png",
  // },



  // {
  //   name: "Fox-Star-Studios ",
  //   thumbnail: "/LogoLibrary/Fox-Star-Studios copy.png",
  //   url: "/LogoLibrary/Fox-Star-Studios copy.png",
  // },
  // {
  //   name: "Happy-Madison-Productions ",
  //   thumbnail: "/LogoLibrary/Happy-Madison-Productions copy.png",
  //   url: "/LogoLibrary/Happy-Madison-Productions copy.png",
  // },
  // {
  //   name: "Legendary-entertainment ",
  //   thumbnail: "/LogoLibrary/Legendary-entertainment copy.png",
  //   url: "/LogoLibrary/Legendary-entertainment copy.png",
  // },
  // {
  //   name: "Lionsgate  ",
  //   thumbnail: "/LogoLibrary/Lionsgate copy.png",
  //   url: "/LogoLibrary/Lionsgate copy.png",
  // },



  // {
  //   name: "Lucasfilm",
  //   thumbnail: "/LogoLibrary/Lucasfilm copy.png",
  //   url: "/LogoLibrary/Lucasfilm copy.png",
  // },
  // {
  //   name: "Magnolia-Pictures  ",
  //   thumbnail: "/LogoLibrary/Magnolia-Pictures copy.png",
  //   url: "/LogoLibrary/Magnolia-Pictures copy.png",
  // },
  // {
  //   name: "Metro-Goldwyn-Mayer ",
  //   thumbnail: "/LogoLibrary/Metro-Goldwyn-Mayer copy.png",
  //   url: "/LogoLibrary/Metro-Goldwyn-Mayer copy.png",
  // },
  // {
  //   name: "Miramax ",
  //   thumbnail: "/LogoLibrary/Miramax copy.png",
  //   url: "/LogoLibrary/Miramax copy.png",
  // },



  // {
  //   name: "New-Line-Cinema  ",
  //   thumbnail: "/LogoLibrary/New-Line-Cinema copy.png",
  //   url: "/LogoLibrary/New-Line-Cinema copy.png",
  // },
  // {
  //   name: "Paramount-Pictures  ",
  //   thumbnail: "/LogoLibrary/Paramount-Pictures copy.png",
  //   url: "/LogoLibrary/Paramount-Pictures copy.png",
  // },
  // {
  //   name: "Participant ",
  //   thumbnail: "/LogoLibrary/Participant copy.png",
  //   url: "/LogoLibrary/Participant copy.png",
  // },
  // {
  //   name: "Pixar",
  //   thumbnail: "/LogoLibrary/Pixar copy.png",
  //   url: "/LogoLibrary/Pixar copy.png",
  // },



  // {
  //   name: "Relativity-Media ",
  //   thumbnail: "/LogoLibrary/Relativity-Media copy.png",
  //   url: "/LogoLibrary/Relativity-Media copy.png",
  // },
  // {
  //   name: "Screen-Gems  ",
  //   thumbnail: "/LogoLibrary/Screen-Gems copy.png",
  //   url: "/LogoLibrary/Screen-Gems copy.png",
  // },
  // {
  //   name: "Searchlight-Pictures ",
  //   thumbnail: "/LogoLibrary/Searchlight-Pictures copy.png",
  //   url: "/LogoLibrary/Searchlight-Pictures copy.png",
  // },
  // {
  //   name: "Sony-Pictures ",
  //   thumbnail: "/LogoLibrary/Sony-Pictures copy.png",
  //   url: "/LogoLibrary/Sony-Pictures copy.png",
  // },



  // {
  //   name: "StudioCanal",
  //   thumbnail: "/LogoLibrary/StudioCanal copy.png",
  //   url: "/LogoLibrary/StudioCanal copy.png",
  // },
  // {
  //   name: "Summit-Entertainment ",
  //   thumbnail: "/LogoLibrary/Summit-Entertainment copy.png",
  //   url: "/LogoLibrary/Summit-Entertainment copy.png",
  // },
  // {
  //   name: "The-Weinstein-Company",
  //   thumbnail: "/LogoLibrary/The-Weinstein-Company copy.png",
  //   url: "/LogoLibrary/The-Weinstein-Company copy.png",
  // },
  // {
  //   name: "Touchstone-Pictures  ",
  //   thumbnail: "/LogoLibrary/Touchstone-Pictures copy.png",
  //   url: "/LogoLibrary/Touchstone-Pictures copy.png",
  // },



  // {
  //   name: "TriStar-Pictures ",
  //   thumbnail: "/LogoLibrary/TriStar-Pictures copy.png",
  //   url: "/LogoLibrary/TriStar-Pictures copy.png",
  // },
  // {
  //   name: "United-Artists ",
  //   thumbnail: "/LogoLibrary/United-Artists copy.png",
  //   url: "/LogoLibrary/United-Artists copy.png",
  // },
  // {
  //   name: "Universal-Pictures  ",
  //   thumbnail: "/LogoLibrary/Universal-Pictures copy.png",
  //   url: "/LogoLibrary/Universal-Pictures copy.png",
  // },
  // {
  //   name: "Working-Title-Films",
  //   thumbnail: "/LogoLibrary/Working-Title-Films copy.png",
  //   url: "/LogoLibrary/Working-Title-Films copy.png",
  // },



  // {
  //   name: "SAG-AFTRA_Horizontal",
  //   thumbnail: "/LogoLibrary/SAGAFTRA_Trans_Horz.png",
  //   url: "/LogoLibrary/SAGAFTRA_Trans_Horz.png",
  // },
  // {
  //   name: "SAG-AFTRA_Vertical",
  //   thumbnail: "/LogoLibrary/SAGAFTRA_Trans_Vert.png",
  //   url: "/LogoLibrary/SAGAFTRA_Trans_Vert.png",
  // },
  // {
  //   name: "alexa-arri-logo.png",
  //   thumbnail: "/LogoLibrary/ARRI_Trans.png",
  //   url: "/LogoLibrary/ARRI_Trans.png",
  // },
  // {
  //   name: "AT_TP_UntoldStories_01.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_01.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_01.png",
  // },



  // {
  //   name: "AT_TP_UntoldStories_02.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_02.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_02.png",
  // },
  // {
  //   name: "AT_TP_UntoldStories_03.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_03.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_03.png",
  // },
  // {
  //   name: "AT_TP_UntoldStories_04.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_04.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_04.png",
  // },
  // {
  //   name: "AT_TP_UntoldStories_05.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_05.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_05.png",
  // },



  // {
  //   name: "AT_TP_UntoldStories_06.png",
  //   thumbnail: "/LogoLibrary/AT_TP_UntoldStories_06.png",
  //   url: "/LogoLibrary/AT_TP_UntoldStories_06.png",
  // },
  // {
  //   name: "Offical_selection_01.png",
  //   thumbnail: "/LogoLibrary/Offical_selection_01.png",
  //   url: "/LogoLibrary/Offical_selection_01.png",
  // },
  // {
  //   name: "Offical_selection_02.png",
  //   thumbnail: "/LogoLibrary/Offical_selection_02.png",
  //   url: "/LogoLibrary/Offical_selection_02.png",
  // },
];
